<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/proxy-hosting-info.html" name="c-proxy-hosting-info">
<link rel="ractive" href="../components/proxy-head.html" name="c-proxy-head">
<link rel="ractive" href="../components/new-infographic-banner.html" name="c-new-infographic-banner">
<link rel="ractive" href="../components/proxy-request-bandwidth-stats.html" name="c-proxy-request-bandwidth-stats">
<link rel="ractive" href="../components/periods-dropdown.html" name="c-periods-dropdown">
<link rel="ractive" href="../components/top-stats-table.html" name="c-top-stats-table">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-header></c-header>

	<div class="p-proxy-project">
		<div class="content-wrapper">
			<c-proxy-head name="{{projectApiName}}"
				link="{{projectLink}}"
				docsLink="{{docsLink}}"
				jsDelivrLink="/oss-cdn/{{name}}">
				{{#partial title}}
					{{projectTitle}}
				{{/partial}}

				{{#partial descr}}
					{{projectDescr}}
				{{/partial}}

				{{#partial img}}
					<img width="{{projectImgW}}" height="{{projectImgH}}" src="{{@shared.assetsHost}}{{projectImgSrc}}">
				{{/partial}}
			</c-proxy-head>

			<div class="divider"></div>

			<div class="ctrls-block">
				<div class="ctrls-block-title">Statistics</div>
				<div class="ctrls-block-ctrls">
					<div class="chart-type-ctrl">
						<span>Show numbers of</span>

						<input id="chart-switch"
							type="checkbox"
							class="chart-type-switch {{#if showChartBandwidth}}checked{{/if}}"
							twoway="false">

						<label for="chart-switch" on-click="@this.set('showChartBandwidth', !showChartBandwidth)">
							<span>Requests</span>
							<span>Bandwidth</span>
							<div class="slide-select">
								<div class="selected"></div>
							</div>
						</label>
					</div>

					<div class="data-range-ctrl">
						<span>Data range:</span>

						<c-periods-dropdown selectedValue="{{periodData.periodValue}}" selectHandler="{{@this.handlePeriodSelecting()}}"></c-periods-dropdown>
					</div>
				</div>
			</div>

			<c-proxy-request-bandwidth-stats name="{{projectApiName}}" periodData="{{periodData}}"></c-proxy-request-bandwidth-stats>

			{{#if noPackageStatsData}}
				<div class="no-data-wrapper">
					<img width="180" height="152" src="{{@shared.assetsHost}}/img/no-data-chart-main.svg">
					<span>No statistics yet</span>
					<span>This is probably not a very popular package :(</span>
				</div>
			{{else}}
				<div class="chart-ctrls">
					<div class="chart-ctrls-title">Stats for last {{~/periodData.periodText}}</div>
					<div class="chart-ctrls-group-by">
						<span>
							Group by:
						</span>

						<div class="btn-group">
							<button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span>{{~/usageChartGroupByValues[usageChartGroupBy].value}}</span>
								<i class="fa fa-angle-down" aria-hidden="true"></i>
							</button>

							<ul class="dropdown-menu">
								{{#each ~/usageChartGroupByValues}}
									<li>
										{{#if this.isAvailable}}
											<a on-click="@this.set('usageChartGroupBy', @key)">{{this.value}}</a>
										{{/if}}
									</li>
								{{/each}}
							</ul>
						</div>
					</div>
				</div>

				<div class="chart-wrapper">
					<canvas id="cdn-stats-chart"></canvas>
				</div>
			{{/if}}

			<div class="files-table">
				<c-top-stats-table
					title="Top files"
					responseData="{{~/topFiles}}"
					responseHeaders="{{topFilesHeaders}}"
					isBandwidth="{{~/showChartBandwidth}}"
					pageLimit="{{topFilesLimit}}"
					page="{{topFilesPage}}"
					paginationLimits="{{[10, 20, 50, 100]}}"
					valueKey="{{showChartBandwidth ? 'bandwidth' : 'hits'}}">
					{{#partial column1}}
						{{name}}
					{{/partial}}
				</c-top-stats-table>
			</div>

			<div class="explore-all-endpoints">
				<a href="/oss-cdn/" class="btn-arrow">
					<span>Explore all custom endpoints</span>
					<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg">
				</a>
			</div>

			<c-new-infographic-banner>
				{{#partial text}}
					Learn more about<br />
					the infrastructure that<br />
					powers <a href="/network/infographic" target="_blank" class="router-ignore">jsDelivr</a>
				{{/partial}}
			</c-new-infographic-banner>

			<c-proxy-hosting-info></c-proxy-hosting-info>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const stats = require('../../assets/js/utils/stats');
	const initCharts = require('../../assets/js/utils/charts');
	const listeners = require('../../assets/js/utils/listeners');
	const ossCdnProjects = require('../../assets/json/oss-cdn-projects.json');

	component.exports = {
		computed: {
			title () {
				return this.get('projectTitle') + ' CDN by jsDelivr';
			},
			description () {
				return `A free, fast, and reliable CDN for ${this.get('projectTitle')}. ${this.get('projectDescr')}`;
			},
			usageChartGroupByValues () {
				return stats.groupByOptions[this.get('periodData').periodType];
			},
		},
		data () {
			return {
				periodData: { periodText: 'quarter', periodValue: 'quarter', periodType: 's-quarter' },
				showChartBandwidth: false,
				usageChartGroupBy: 'day',
				noPackageStatsData: false,
				projectTitle: '',
				projectDescr: '',
				projectImgSrc: '',
				projectImgW: '',
				projectImgH: '',
				rawStatsData: {},
				preparedStatsData: {},
				cdnOssRes: null,
				topFiles: null,
				topFilesHeaders: null,
				topFilesLimit: 10,
				topFilesPage: 1,
			};
		},
		oninit () {
			this.observe('name', (name) => {
				this.set('projectTitle', ossCdnProjects[name].title);
				this.set('projectDescr', ossCdnProjects[name].descr);
				this.set('projectImgW', ossCdnProjects[name].imgWidth);
				this.set('projectImgH', ossCdnProjects[name].imgHeight);
				this.set('projectImgSrc', ossCdnProjects[name].imgSrc);
				this.set('projectLink', ossCdnProjects[name].link);
				this.set('projectApiName', ossCdnProjects[name].apiCdnName);
				this.set('docsLink', ossCdnProjects[name].docsLink);
			});

			if (!Ractive.isServer) {
				// get files for a specific cdn-oss
				this.observe('projectApiName topFilesPage topFilesLimit showChartBandwidth', () => {
					let projectApiName = this.get('projectApiName');
					let topFilesLimit = this.get('topFilesLimit');
					let topFilesPage = this.get('topFilesPage');
					let filterBy = this.get('showChartBandwidth') ? 'bandwidth' : 'hits';

					http.getCdnOssFiles(projectApiName, filterBy, topFilesLimit, topFilesPage).then((result) => {
						this.set('cdnOssRes', result);
					});
				});

				// handle cdn oss files data
				this.observe('cdnOssRes', () => {
					let { response, responseHeaders } = this.get('cdnOssRes');

					this.set('topFiles', response.map(i => ({
						name: i.name,
						hits: i.hits.total,
						bandwidth: i.bandwidth.total,
					})));

					this.set('topFilesHeaders', responseHeaders);
				}, { init: false });

				// handle chart period changes by updating groupBy options and chart data fetching
				this.observe('periodData', (periodData) => {
					let period = periodData.periodValue;
					let projectApiName = this.get('projectApiName');

					// prevent chart data fetching from the back when period is DAY, left it as it was prev
					if (period === 'day') { return; }

					http.fetchCdnOssStats(projectApiName, period).then((response) => {
						if (!response.hits.total || !response.bandwidth.total) {
							this.set('noPackageStatsData', true);
							return;
						}

						this.set('noPackageStatsData', false);
						// once new data fetched we should set groupBy to default value before raw data set
						this.set('usageChartGroupBy', 'day');
						this.set('rawStatsData', response);
					});
				});

				// handle raw data and prepare it for chart
				// screenWidth to observe when screen width is resized to recreate chart
				this.observe('rawStatsData showChartBandwidth usageChartGroupBy screenWidth', () => {
					let rawStatsData = this.get('rawStatsData');
					let chartPeriodType = this.get('periodData').periodType;
					let showChartBandwidth = this.get('showChartBandwidth');
					let usageChartGroupBy = this.get('usageChartGroupBy');
					let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;
					let dataType = showChartBandwidth ? 'bandwidth' : 'hits';

					// collect X-Axis dates, group data by period, get
					let {
						values,
						labels,
						labelsStartEndPeriods,
						maxRangeValue,
						valueUnits,
					} = _.getPreparedDataForBarChart(rawStatsData[dataType], usageChartGroupBy, chartPeriodType, showChartBandwidth);

					// get bat thickness of the chart depending on screen resolution, chartPeriodType and groupBy
					let chartBarThickness = _.calcChartBarThicknessByResolution(chartPeriodType, usageChartGroupBy);

					// set prepared data for chart
					this.set('preparedStatsData', {
						data: values,
						labels,
						labelsStartEndPeriods,
						maxRangeValue,
						showChartBandwidth,
						barThickness: chartBarThickness,
						useYAxisBorderPlugin: screenWidth >= 768,
						yAxisPadding: screenWidth >= 768 ? 20 : 8,
						valueUnits,
					});
				}, { init: false });
			}
		},
		onrender () {
			let statsChart;

			initCharts().then(({ createBarChart }) => {
				// draw a chart when data is ready
				this.observe('preparedStatsData', (preparedStatsData) => {
					if (!preparedStatsData) { return; }

					let {
						labels,
						maxRangeValue,
						data,
						showChartBandwidth,
						barThickness,
						useYAxisBorderPlugin,
						yAxisPadding,
						labelsStartEndPeriods,
						valueUnits,
					} = preparedStatsData;
					let statsChartCanvasEl = this.find('#cdn-stats-chart');

					if (!preparedStatsData || !statsChartCanvasEl) { return; }

					if (statsChart) {
						statsChart.destroy();
						statsChart = null;
					}

					let chartData = {
						labels,
						datasets: [{
							data,
							borderWidth: 0,
							barThickness,
							hoverBackgroundColor: '#F65128',
						}],
						labelsStartEndPeriods,
						valueUnits,
					};
					let chartSettings = {
						useYAxisBorderPlugin,
						useExternalTooltip: true,
						useImprovedTooltip: true,
						externalTooltipVerticalOffset: 40,
					};
					let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
					let chartConfig = {
						options: {
							scales: {
								x: {
									display: true,
									ticks: {
										autoSkip: false,
										color: '#5C667A',
										font: {
											size: 12,
											family: 'Lexend, sans-serif',
											lineHeight: 2,
										},
										// return nothing when labelValue array is empty
										// this way we will not get italicized text when all ticks can't be displayed at once normally
										callback (value) {
											let labelValue = this.getLabelForValue(value);

											if (labelValue.length) {
												return labelValue;
											}
										},
									},
									grid: {
										display: false,
									},
									border: {
										display: false,
									},
								},
								y: {
									display: true,
									min: 0,
									suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
									ticks: {
										padding: yAxisPadding,
										count: 9,
										color: '#5C667A',
										crossAlign: 'near',
										font: {
											size: 12,
											family: 'Lexend, sans-serif',
										},
										callback (value) {
											let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);

											if (_.isMobileScreen()) {
												return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
											}

											return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
										},
									},
									grid: {
										display: false,
									},
									border: {
										display: false,
									},
								},
							},
						},
					};

					statsChart = createBarChart(statsChartCanvasEl, chartData, chartSettings, chartConfig);
				});
			});

			listeners.screenWidthListener(this);
		},
		handlePeriodSelecting () {
			return (periodData) => {
				this.set('periodData', periodData);
			};
		},
	};
</script>
